import { isEmpty } from './tool';
export { getCent2Yuan,
// 以分为单位的金额转换为以元为单位
getYuan2Cent,
// 以元为单位的金额转换为以分为单位
getCent2Millon,
// 以分为单位的金额转换为以万为单位
getCent2Billion,
// 以分为单位的金额转换为以亿为单位
formatMoney,
// 金额自定义转换
getLegalDigital // 金额格式化
};
/**
 * 以分为单位的金额转换为以元为单位
 * @param money 以分为单位的金额
 * @param flag 整数部分是否加千分号
 * @returns
 */
function getCent2Yuan(money, flag) {
  return formatMoney(money, flag, 2);
}
/**
 * 以分为单位的金额转换为以万为单位
 * @param money 以分为单位的金额
 * @param flag 整数部分是否加千分号
 * @param round 是否四舍五入保留两位小数，若为 false 采用截取方式保留，默认为 true
 * @returns
 */
function getCent2Millon(money, flag) {
  var round = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return formatMoney(money, flag, 6, 2, round);
}
/**
 * 以分为单位的金额转换为以亿为单位
 * @param money 以分为单位的金额
 * @param flag 整数部分是否加千分号
 * @param round 是否四舍五入保留两位小数，若为 false 采用截取方式保留，默认为 true
 * @returns
 */
function getCent2Billion(money, flag) {
  var round = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return formatMoney(money, flag, 10, 2, round);
}
/**
 * 金额格式化
 * @param money 以分为单位的金额
 * @param flag 整数部分是否加千分号
 * @param len 小数点往左移动位数
 * @param decimal 保留小数位数
 * @param round 是否四舍五入保留小数，若为 false 采用截取方式保留，默认为 true
 * @returns
 */
function formatMoney(money, flag) {
  var len = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var decimal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2;
  var round = arguments.length > 4 ? arguments[4] : undefined;
  if (isEmpty(money)) {
    return '';
  }
  money = String(money);
  if (money.indexOf('.') >= 0 || decimal > len) {
    return money;
  }
  var sign = '';
  var result = '';
  if (money.substring(0, 1) === '-' || money.substring(0, 1) === '+') {
    sign = money.substring(0, 1);
    money = money.substring(1);
  }
  money = String(Number(money));
  if (money.length <= len) {
    result = '0.' + money.padStart(len, '0');
  } else {
    result = money.slice(0, -len) + '.' + money.slice(-len);
  }
  // 保留小数
  if (round) {
    result = Number(result).toFixed(decimal);
  } else if (decimal < len) {
    result = result.slice(0, decimal - len);
  }
  // 整数部分是否加千分号
  flag && (result = result.replace(/(\d{1,3})(?=(?:\d{3})+\.)/g, '$1,'));
  return sign + result;
}
/**
 * 以元为单位的金额转换为以分为单位
 * @param money 以元为单位的金额
 * @returns
 */
function getYuan2Cent(money) {
  if (isEmpty(money)) return '';
  // 剔除千分号
  money = String(money).replace(/[,]/g, '');
  var m = (money.split('.')[1] || []).length;
  money = Number(money.replace('.', '')) * 100 / Math.pow(10, m);
  return String(Math.trunc(money));
}
/**
 * 金额格式化
 * @param money 输入的金额
 * @returns
 */
function getLegalDigital(money) {
  if (isEmpty(money)) return '';
  money = String(money);
  // 剔除千分号
  var value = money.replace(/[^\d.]/g, '') // 不允许输入数字和小数点以外的数
  .replace(/^\./g, '') // 第一位不允许输入小数点
  .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') // 不允许输入一次以上的小数点
  .replace(/(\d+)\.(\d{1,2}).*$/, '$1.$2') // 小数位不允许超过两位
  .replace(/(\d{1,5})([^.]*)(\.(\d{1,2}).*)?$/, '$1$3') // 金额不大于10万
  .replace(/^([0]{1,})(\d{1,}.*)/, '$2').replace(/^([0]{1,})(0\..*)/, '$2');
  return value;
}